module.exports = __webpack_public_path__ + "img/portrait-059.22c4fdfe.jpg";